import { render, staticRenderFns } from "./Subject.vue?vue&type=template&id=2d1e3f72&"
import script from "./Subject.vue?vue&type=script&lang=js&"
export * from "./Subject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d1e3f72')) {
      api.createRecord('2d1e3f72', component.options)
    } else {
      api.reload('2d1e3f72', component.options)
    }
    module.hot.accept("./Subject.vue?vue&type=template&id=2d1e3f72&", function () {
      api.rerender('2d1e3f72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Input/Subject.vue"
export default component.exports